import {Box, Grid, Typography} from '@mui/material';
import '../../pages/GrowthHackTableData/GrowthHackTableData.scss';

// Removed verbose lorem ipsum placeholders. The component now relies solely on props.
// If a prop is missing or empty, "Not available" will be displayed.

export default function InfoCard({ title, growthHackType, GrowthHackSubCategory, Urgency, Date, GrowthHackDescriptionGenAI }) {

    return (
            <Box className="info-card-content custom-card">
            <Typography className="text-accent-yellow" style={{ color: '#FFD600' }}>
                {title?.trim() ? title : 'Not available'}
            </Typography>
            <div className="grid-container">
                <Grid container spacing={6} className="metadata-row">
                    <Grid className="metadata-item">
                        <Typography component="span" className="metadata-label">Growth Hack Type</Typography>
                        <Typography component="span" className="metadata-value">{growthHackType?.trim() ? growthHackType : 'Not available'}</Typography>
                    </Grid>
                    <Grid className="metadata-item">
                        <Typography component="span" className="metadata-label">Category</Typography>
                        <Typography component="span" className="metadata-value">{GrowthHackSubCategory?.trim() ? GrowthHackSubCategory : 'Not available'}</Typography>
                    </Grid>
                    <div style={{ marginLeft: "auto" }}>
                        <Grid item className="metadata-item" >
                            <Typography component="span" className="metadata-label">Urgency</Typography>
                            <Typography style={{ color: "#FFA500" }} size="small" >{Urgency?.trim() ? Urgency : 'Not available'}</Typography>
                    </Grid>
                    </div>
                    <Grid className="metadata-item">
                        <Typography component="span" className="metadata-label">Date</Typography>
                        <Typography component="span" className="metadata-value">{Date?.trim() ? Date : 'Not available'}</Typography>
                    </Grid>
                </Grid>
            </div>
        </Box>
    );
}
